import { useTheme } from '@/components/theme-provider';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          success:
            'group-[.toaster]:border-l-4 group-[.toaster]:border-l-green-500 group-[.toaster]:bg-green-50 dark:group-[.toaster]:bg-green-950/20',
          error:
            'group-[.toaster]:border-l-4 group-[.toaster]:border-l-red-500 group-[.toaster]:bg-red-50 dark:group-[.toaster]:bg-red-950/20',
          info: 'group-[.toaster]:border-l-4 group-[.toaster]:border-l-blue-500 group-[.toaster]:bg-blue-50 dark:group-[.toaster]:bg-blue-950/20',
          warning:
            'group-[.toaster]:border-l-4 group-[.toaster]:border-l-yellow-500 group-[.toaster]:bg-yellow-50 dark:group-[.toaster]:bg-yellow-950/20',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
